import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import { motion, AnimatePresence } from "framer-motion";

export default function LineChart() {
  const lineChartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    const ctx = lineChartRef.current.getContext("2d");

    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    chartInstanceRef.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: ["1-1", "1-2", "2-1", "2-2", "3-1", "3-2", "4-1"],
        datasets: [
          {
            label: "SGPA",
            data: [9.23, 9.23, 9.3, 9.65, 10, 9.56, 8.7],
            borderColor: "#00A86B",
            fill: false,
            tension: 0.4,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        animations: {
          tension: {
            duration: 1000,
            easing: "easeInQuad",
            from: 0.5,
            to: 0.1,
            loop: true,
          },
          radius: {
            duration: 400,
            easing: "linear",
            loop: (context) => context.active,
          },
        },
        elements: {
          point: {
            radius: 5,
            backgroundColor: "#00A86B",
            hoverRadius: 7,
          },
        },
        scales: {
          y: {
            beginAtZero: false,
            suggestedMin: 5,
            suggestedMax: 10,
            ticks: {
              stepSize: 0.4,
              color: "#00A86B",
            },
            title: {
              display: true,
              text: "SGPA",
              color: "#00A86B",
            },
            grid: {
              color: "#00A86B33",
            },
            borderColor: "#00A86B33",
          },
          x: {
            ticks: {
              color: "#00A86B",
            },
            title: {
              display: true,
              text: "B.Tech [2021-2025] Semesters",
              color: "#00A86B",
            },
            grid: {
              color: "#00A86B33",
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              color: "#00A86B",
            },
          },
        },
      },
    });

    // Cleanup function to destroy the chart instance when the component unmounts
    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, []);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        exit={{ y: 40, opacity: 0 }}
        className="lc-center l-chart"
      >
        <canvas id="lineChart" className="linechart" ref={lineChartRef} />
      </motion.div>
    </AnimatePresence>
  );
}
